import { dayjs } from '@tunasong/models'
import type { MaterialColor } from '@tunasong/plugin-lib'
import { HBox, Typography, VBox } from '@tunasong/ui-lib'
import React from 'react'
import type { FC, Ref } from 'react'

export interface ChatItemProps {
  name: string
  timestamp: string
  UserIcon: FC

  color?: MaterialColor

  children: React.ReactNode
  actions?: React.ReactNode

  highlight?: boolean
  type: 'message' | 'response' | 'assistant'

  ref: Ref<unknown>
}

export const ChatItem: FC<ChatItemProps> = props => {
  const { name, actions, UserIcon, type, highlight, timestamp, children, ref } = props

  const iconBox = (
    <div>
      <UserIcon />
    </div>
  )
  const contentBox = (
    <div
      style={{
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16,
        paddingBottom: 16,
        margin: 8,
        borderWidth: 2,
        borderStyle: 'solid',
        borderRadius: 8,
        borderColor: 'var(--tuna-palette-action-hover)',
        backgroundColor: 'var(--tuna-palette-action-hover)',
        width: '100%',
      }}
    >
      {children}
    </div>
  )

  const layout =
    type === 'message' ? (
      <>
        {iconBox}
        {contentBox}
        {actions}
      </>
    ) : (
      <>
        {actions}
        {contentBox}
        {iconBox}
      </>
    )
  const position = type === 'message' ? 'left' : 'right'
  const flexPosition = type === 'message' ? 'flex-start' : 'flex-end'
  const textStyle = { marginLeft: position === 'left' ? 48 : 0, marginRight: position === 'right' ? 48 : 0 }

  return (
    <VBox style={{ alignItems: flexPosition }} ref={ref}>
      <Typography
        style={{ marginTop: 16, ...textStyle, fontSize: 12, color: 'var(--tuna-palette-text-secondary)' }}
        variant="body2"
      >
        {name}
      </Typography>
      <HBox
        style={{
          width: '90%',
          alignItems: 'center',
          justifyContent: flexPosition,
          ...(highlight
            ? {
                borderColor: 'var(--tuna-palette-success-light)',
                borderStyle: 'dashed',
                borderWidth: 2,
              }
            : {}),
        }}
      >
        {layout}
      </HBox>
      <div style={{ marginLeft: position === 'left' ? 48 : 0, marginRight: position === 'right' ? 48 : 0 }}>
        <Typography color="var(--tuna-palette-primary-dark)" variant="caption">
          {dayjs(timestamp).fromNow()}
        </Typography>
      </div>
    </VBox>
  )
}

export default ChatItem
